<template>
  <v-card class="card-shadow px-4 py-2 overflow-hidden border-radius-xl">
    <v-row>
      <v-col cols="6">
        <div class="d-flex align-center">
          <h5 class="mb-2 text-h5 text-typo font-weight-bold">
            {{ clockSetting.name }}
          </h5>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="checkAbsentClock"
                :ripple="false"
                class="ms-2"
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="blue">mdi-table-check</v-icon>
              </v-btn>
            </template>
            <span>檢查未打卡</span>
          </v-tooltip>
        </div>
        <p class="mb-4 text-body text-sm">{{ clockSetting.description }}</p>
      </v-col>
      <v-col cols="6" class="d-flex justify-end" v-if="!editMode">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="confirmClearData"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon>mdi-database-refresh</v-icon>
            </v-btn>
          </template>
          <span>重新載入並清除現有資料</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="confirmReload"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon>mdi-restore</v-icon>
            </v-btn>
          </template>
          <span>重新載入</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="toggleEditMode"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>編輯設定</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="deleteClockSetting"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
              color="red"
              :disabled="onlyOneSetting"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>刪除設定</span>
        </v-tooltip>
      </v-col>
      <v-col cols="6" class="d-flex justify-end" v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="saveChanges"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon color="red">mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>保存設定</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="cancelEdit"
              :ripple="false"
              class="ms-2"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>取消編輯</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <!-- Edit mode form -->
    <v-row v-if="editMode" class="mt-4">
      <v-col cols="12" md="6" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">上下班時間</h6>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="editedClockSetting.name"
              label="名稱"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              class="
                font-size-input
                placeholder-lighter
                text-light-input
                border border-radius-md
                mt-2
              "
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="editedClockSetting.description"
              label="描述"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              class="
                font-size-input
                placeholder-lighter
                text-light-input
                border border-radius-md
                mt-2
              "
            ></v-text-field>
          </v-col>
          <!-- clock_in_time -->
          <v-col cols="4">
            <v-menu
              v-model="timeMenus.clockIn"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatToHHmm(editedClockSetting.clock_in_time)"
                  label="上班時間"
                  outlined
                  dense
                  readonly
                  :disabled="isFlexMode"
                  v-bind="attrs"
                  v-on="on"
                  @click="!isFlexMode && (timeMenus.clockIn = true)"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="editedClockSetting.clock_in_time"
                format="24hr"
                full-width
                color="blue"
                @input="updateLunchByClockIn"
                @change="handleClockInChange"
                :disabled="isFlexMode"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="4">
            <v-text-field
              v-model.number="editedClockSetting.clock_in_notify"
              label="上班通知分鐘"
              type="number"
              outlined
              dense
              :rules="[nonNegativeRule]"
            ></v-text-field>
          </v-col>
          <!-- clock_in_allow_time -->
          <v-col cols="4">
            <v-text-field
              v-model.number="editedClockSetting.clock_in_allow_time"
              label="允許提前打卡分鐘"
              type="number"
              outlined
              dense
              :rules="[nonNegativeRule]"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="timeMenus.clockOut"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatToHHmm(editedClockSetting.clock_out_time)"
                  label="下班時間"
                  outlined
                  dense
                  readonly
                  :disabled="isFlexMode"
                  v-bind="attrs"
                  v-on="on"
                  @click="!isFlexMode && (timeMenus.clockOut = true)"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="editedClockSetting.clock_out_time"
                format="24hr"
                full-width
                color="blue"
                @change="timeMenus.clockOut = false"
                :disabled="isFlexMode"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model.number="editedClockSetting.clock_out_notify"
              label="下班通知分鐘"
              type="number"
              outlined
              dense
              :rules="[nonNegativeRule]"
            ></v-text-field>
          </v-col>
          <!-- clock_out_allow_time -->
          <v-col cols="4">
            <v-text-field
              v-model.number="editedClockSetting.clock_out_allow_time"
              label="允許遲到打卡分鐘"
              type="number"
              outlined
              dense
              :rules="[nonNegativeRule]"
            ></v-text-field>
          </v-col>
        </v-row>

        <h6 class="text-subtitle-1 font-weight-bold mt-4">午休（休息1)設定</h6>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="editedClockSetting.lunch_break"
              label="午休"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
              :disabled="isFlexMode"
            ></v-switch>
          </v-col>
          <template v-if="editedClockSetting.lunch_break">
            <v-col cols="6">
              <v-menu
                v-model="timeMenus.lunchStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatToHHmm(editedClockSetting.lunch_break_start)"
                    label="午休開始時間"
                    outlined
                    dense
                    readonly
                    :disabled="isFlexMode"
                    v-bind="attrs"
                    v-on="on"
                    @click="!isFlexMode && (timeMenus.lunchStart = true)"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="editedClockSetting.lunch_break_start"
                  format="24hr"
                  full-width
                  color="blue"
                  @change="timeMenus.lunchStart = false"
                  :disabled="isFlexMode"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="timeMenus.lunchEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatToHHmm(editedClockSetting.lunch_break_end)"
                    label="午休結束時間"
                    outlined
                    dense
                    readonly
                    :disabled="isFlexMode"
                    v-bind="attrs"
                    v-on="on"
                    @click="!isFlexMode && (timeMenus.lunchEnd = true)"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="editedClockSetting.lunch_break_end"
                  format="24hr"
                  full-width
                  color="blue"
                  @change="timeMenus.lunchEnd = false"
                  :disabled="isFlexMode"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </template>
        </v-row>

        <h6 class="text-subtitle-1 font-weight-bold mt-4">休息2設定</h6>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="editedClockSetting.rest_1_start_enable"
              label="啟用休息2"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
              :disabled="isFlexMode"
            ></v-switch>
          </v-col>
          <template v-if="editedClockSetting.rest_1_start_enable">
            <v-col cols="6">
              <v-menu
                v-model="timeMenus.rest1Start"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatToHHmm(editedClockSetting.rest_1_start)"
                    label="休息一開始時間"
                    outlined
                    dense
                    readonly
                    :disabled="isFlexMode"
                    v-bind="attrs"
                    v-on="on"
                    @click="!isFlexMode && (timeMenus.rest1Start = true)"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="editedClockSetting.rest_1_start"
                  format="24hr"
                  full-width
                  color="blue"
                  @change="timeMenus.rest1Start = false"
                  :disabled="isFlexMode"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="timeMenus.rest1End"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatToHHmm(editedClockSetting.rest_1_end)"
                    label="休息一結束時間"
                    outlined
                    dense
                    readonly
                    :disabled="isFlexMode"
                    v-bind="attrs"
                    v-on="on"
                    @click="!isFlexMode && (timeMenus.rest1End = true)"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="editedClockSetting.rest_1_end"
                  format="24hr"
                  full-width
                  color="blue"
                  @change="timeMenus.rest1End = false"
                  :disabled="isFlexMode"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="12" md="6" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">打卡方式</h6>
        <v-row>
          <v-col cols="12" md="12">
            <v-switch
              v-model="editedClockSetting.gps_enable"
              label="GPS打卡"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
            ></v-switch>
            <template v-if="editedClockSetting.gps_enable">
              <template v-if="multple_gps">
                <!-- Multiple GPS items list -->
                <div class="d-flex align-center mt-2">
                  <v-btn
                    class="
                      font-weight-600
                      text-capitalize
                      drawer-toggler
                      btn-toggler-hover
                      py-2
                      px-4
                      my-2
                      rounded-sm
                      text-white
                    "
                    color="purple"
                    @click="addGpsItem"
                    small
                  >
                    新增地點
                  </v-btn>
                </div>
                <v-card
                  v-for="(item, idx) in gpsItems"
                  :key="idx"
                  class="border-radius-xl card-shadow pa-4 mb-3"
                  color="#E3F2FD"
                >
                  <!-- location -->
                  <div class="d-flex align-center">
                    <v-text-field
                      v-model="item.location"
                      @input="syncCombinedGpsFields()"
                      label="地址"
                      hide-details
                      outlined
                      dense
                      style="background-color: white"
                      class="
                        font-size-input
                        placeholder-lighter
                        text-light-input
                        border border-radius-md
                      "
                    ></v-text-field>
                    <v-btn
                      class="
                        font-weight-600
                        text-capitalize
                        drawer-toggler
                        btn-toggler-hover
                        py-2
                        px-4
                        mx-2
                        rounded-sm
                      "
                      @click="fetchItemGPSFromAddress(idx)"
                      :loading="fetchingGPS"
                      :disabled="!item.location"
                      small
                    >
                      <v-icon small left>mdi-map-marker-radius</v-icon>
                      取經緯度
                    </v-btn>
                  </div>
                  <div class="d-flex align-center mt-2">
                    <v-text-field
                      v-model="item.gps"
                      @input="syncCombinedGpsFields()"
                      label="GPS位置"
                      hide-details
                      outlined
                      dense
                      style="background-color: white"
                      class="
                        font-size-input
                        placeholder-lighter
                        text-light-input
                        border border-radius-md
                      "
                    ></v-text-field>
                    <v-btn
                      class="
                        font-weight-600
                        text-capitalize
                        drawer-toggler
                        btn-toggler-hover
                        py-2
                        px-4
                        mx-2
                        rounded-sm
                      "
                      @click="openItemGPSInGoogleMaps(idx)"
                      :disabled="!isValidGPS(item.gps)"
                      small
                    >
                      <v-icon small left>mdi-map-marker</v-icon>
                      開啟地圖
                    </v-btn>
                    <v-btn
                      class="
                        font-weight-600
                        text-capitalize
                        drawer-toggler
                        btn-toggler-hover
                        py-2
                        px-4
                        ms-2
                        rounded-sm
                        text-white
                      "
                      color="red"
                      @click="removeGpsItem(idx)"
                      small
                    >
                      移除
                    </v-btn>
                  </div>
                </v-card>

                <!-- Combined readonly fields -->
                <v-list-item class="px-0" v-if="clockSetting.gps_enable">
                  <v-list-item-icon class="me-3">
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>GPS打卡</v-list-item-title>
                    <v-list-item-subtitle
                      ><span class="text-red font-weight-bold">地址: </span
                      >{{ clockSetting.location }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      ><span class="text-red font-weight-bold">位置:</span>
                      {{ clockSetting.gps }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      ><span class="text-red font-weight-bold">範圍:</span>
                      {{ clockSetting.gps_scope }} 公尺</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <!-- Single GPS item (original UI) -->
                <!-- location -->
                <div class="d-flex align-center mt-2">
                  <v-text-field
                    v-model="editedClockSetting.location"
                    label="地址"
                    hide-details
                    outlined
                    dense
                    class="
                      font-size-input
                      placeholder-lighter
                      text-light-input
                      border border-radius-md
                    "
                  ></v-text-field>
                  <v-btn
                    class="
                      font-weight-600
                      text-capitalize
                      drawer-toggler
                      btn-toggler-hover
                      py-2
                      px-4
                      mx-2
                      rounded-sm
                    "
                    @click="fetchGPSFromAddress"
                    :loading="fetchingGPS"
                    :disabled="!editedClockSetting.location"
                    small
                  >
                    <v-icon small left>mdi-map-marker-radius</v-icon>
                    取經緯度
                  </v-btn>
                </div>
                <div class="d-flex align-center mt-2">
                  <v-text-field
                    v-model="editedClockSetting.gps"
                    label="GPS位置"
                    hide-details
                    outlined
                    dense
                    class="
                      font-size-input
                      placeholder-lighter
                      text-light-input
                      border border-radius-md
                    "
                  ></v-text-field>
                  <v-btn
                    class="
                      font-weight-600
                      text-capitalize
                      drawer-toggler
                      btn-toggler-hover
                      py-2
                      px-4
                      mx-2
                      rounded-sm
                    "
                    @click="openGPSInGoogleMaps"
                    :disabled="!isValidGPS(editedClockSetting.gps)"
                    small
                  >
                    <v-icon small left>mdi-map-marker</v-icon>
                    開啟地圖
                  </v-btn>
                </div>
                <v-text-field
                  v-model.number="editedClockSetting.gps_scope"
                  label="GPS範圍(公尺)"
                  type="number"
                  hide-details
                  outlined
                  dense
                  class="
                    font-size-input
                    placeholder-lighter
                    text-light-input
                    border border-radius-md
                    mt-2
                  "
                ></v-text-field>
              </template>
            </template>
          </v-col>
          <v-col cols="12" md="12" class="mt-4">
            <v-switch
              v-model="editedClockSetting.qr_fixed_enable"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
              label="固定QR碼打卡"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="12">
            <v-switch
              v-model="editedClockSetting.qr_dynamic_enable"
              label="動態QR碼打卡"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
            ></v-switch>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="editMode" cols="3" md="3" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">最大工時</h6>
        <v-text-field
          v-model="editedClockSetting.working_hours_max"
          label="最大工時"
          type="number"
          hide-details="auto"
          :disabled="isFlexMode"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="editMode">
      <v-col cols="12" md="6" class="pt-0 pb-4">
        <h6 class="text-subtitle-1 font-weight-bold">工作日設定</h6>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="editedClockSetting.fixed_working_days"
              label="固定工作日"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
            ></v-switch>
          </v-col>
          <v-col cols="12" v-if="!editedClockSetting.fixed_working_days">
            <v-select
              v-model="editedClockSetting.schedule_type"
              :items="scheduleTypeOptions"
              item-text="text"
              item-value="value"
              label="班表型態"
              hide-details
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="!editedClockSetting.fixed_working_days">
            <v-switch
              v-model="editedClockSetting.allow_shift_swap"
              label="允許調班"
              :ripple="false"
              class="d-inline-flex mt-0 pt-0 switch ms-auto"
              hide-details
              color="blue"
              inset
            ></v-switch>
          </v-col>
          <v-col cols="6" v-if="editedClockSetting.fixed_working_days">
            <v-select
              v-model="editedClockSetting.recess_day"
              :items="weekdays"
              item-text="text"
              item-value="value"
              label="休息日"
              hide-details
              outlined
              dense
              :disabled="isFlexMode"
            ></v-select>
          </v-col>
          <v-col cols="6" v-if="editedClockSetting.fixed_working_days">
            <v-select
              v-model="editedClockSetting.regular_day"
              :items="weekdays"
              item-text="text"
              item-value="value"
              label="例假日"
              hide-details
              outlined
              dense
              :disabled="isFlexMode"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <h6
          class="text-subtitle-1 font-weight-bold"
          :style="{ color: 'red' }"
        ></h6>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-list-item-title>
              <v-switch
                v-model="editedClockSetting.notify"
                label="未打卡通知"
                :ripple="false"
                class="d-inline-flex mt-0 pt-0 px-2 switch ms-auto"
                hide-details
                color="blue"
                inset
              ></v-switch>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <h6
          class="text-subtitle-1 font-weight-bold"
          :style="{ color: 'red' }"
        ></h6>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-list-item-title>
              <v-switch
                v-model="editedClockSetting.workday_clock_notify_enable"
                label="上下班打卡提醒"
                :ripple="false"
                class="d-inline-flex mt-0 pt-0 px-2 switch ms-auto"
                hide-details
                color="blue"
                inset
              ></v-switch>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

    <v-row v-if="!editMode">
      <v-col cols="12" md="6" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">上下班時間</h6>
        <v-list-item class="px-0">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-clock-time-four-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >上班時間:
              {{
                isFlexMode
                  ? "依照排班時間"
                  : formatToHHmm(clockSetting.clock_in_time)
              }}</v-list-item-title
            >
            <v-list-item-subtitle
              >提前
              {{ clockSetting.clock_in_notify }} 分鐘通知</v-list-item-subtitle
            >
            <!-- clock_in_allow_time -->
            <v-list-item-subtitle
              >允許提前打卡
              {{ clockSetting.clock_in_allow_time }}
              分鐘通知</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="px-0">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-clock-time-eight-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >下班時間:
              {{
                isFlexMode
                  ? "依照排班時間"
                  : formatToHHmm(clockSetting.clock_out_time)
              }}</v-list-item-title
            >
            <v-list-item-subtitle
              >提前
              {{ clockSetting.clock_out_notify }} 分鐘通知</v-list-item-subtitle
            >
            <!-- clock_out_allow_time -->
            <v-list-item-subtitle
              >允許遲到打卡
              {{ clockSetting.clock_out_allow_time }}
              分鐘通知</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <div class="mt-4">
          <h6 class="text-subtitle-1 font-weight-bold">午休(休息1)設定</h6>
          <v-list-item class="px-0">
            <v-list-item-icon class="me-3">
              <v-icon color="primary">mdi-food</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                >午休(休息1)是否打卡:
                {{ clockSetting.lunch_break ? "是" : "否" }}</v-list-item-title
              >
              <template v-if="clockSetting.lunch_break">
                <v-list-item-subtitle
                  >開始時間:
                  {{
                    formatToHHmm(clockSetting.lunch_break_start)
                  }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >結束時間:
                  {{
                    formatToHHmm(clockSetting.lunch_break_end)
                  }}</v-list-item-subtitle
                >
              </template>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div class="mt-4">
          <h6 class="text-subtitle-1 font-weight-bold">休息2 設定</h6>
          <v-list-item class="px-0">
            <v-list-item-icon class="me-3">
              <v-icon color="primary">mdi-coffee</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                >是否啟用:
                {{
                  clockSetting.rest_1_start_enable ? "是" : "否"
                }}</v-list-item-title
              >
              <template v-if="clockSetting.rest_1_start_enable">
                <v-list-item-subtitle
                  >開始時間:
                  {{
                    formatToHHmm(clockSetting.rest_1_start)
                  }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >結束時間:
                  {{
                    formatToHHmm(clockSetting.rest_1_end)
                  }}</v-list-item-subtitle
                >
              </template>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-col v-if="!editMode" cols="12" md="6" class="py-0">
          <h6 class="text-subtitle-1 font-weight-bold">最大工時</h6>
          <v-list-item class="px-0">
            <v-list-item-icon class="me-3">
              <v-icon color="primary">mdi-clock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                clockSetting.working_hours_max
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">打卡方式</h6>
        <v-list-item class="px-0" v-if="clockSetting.gps_enable">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>GPS打卡</v-list-item-title>
            <v-list-item-subtitle
              ><span class="text-red font-weight-bold">地址:</span
              >{{ clockSetting.location }}</v-list-item-subtitle
            >
            <v-list-item-subtitle
              ><span class="text-red font-weight-bold">位置:</span>
              {{ clockSetting.gps }}</v-list-item-subtitle
            >
            <v-list-item-subtitle
              ><span class="text-red font-weight-bold">範圍:</span>
              {{ clockSetting.gps_scope }} 公尺</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="px-0" v-if="clockSetting.qr_fixed_enable">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-qrcode</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="d-flex align-center justify-space-between">
              <v-list-item-title>固定QR碼打卡</v-list-item-title>
              <v-btn
                outlined
                color="#cb0c9f"
                class="font-weight-bolder py-4 px-5"
                small
                @click="generateQRCode(clockSetting.id)"
              >
                產生QR碼
              </v-btn>
            </div>
            <div class="mt-2">
              <v-img
                :src="QRCodeURL"
                alt="QR Code"
                width="120"
                class="border rounded cursor-pointer"
                @click="showQRDialog = true"
              />
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="px-0" v-if="clockSetting.qr_dynamic_enable">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-qrcode-scan</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >動態QR碼打卡
              <!-- call api to get qr code -->
              <v-btn
                v-if="false"
                outlined
                color="#cb0c9f"
                class="font-weight-bolder py-4 px-5"
                small
                @click="generateDynamicQRCode(clockSetting.id)"
              >
                產生動態QR碼
              </v-btn></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

    <v-row v-if="!editMode">
      <v-col cols="12" md="6" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold">工作日設定</h6>
        <v-list-item class="px-0">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-calendar-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              >固定工作日:
              {{
                clockSetting.fixed_working_days ? "是" : "否"
              }}</v-list-item-title
            >
            <v-list-item-subtitle v-if="!clockSetting.fixed_working_days">
              班表型態:
              {{ getScheduleTypeLabel(clockSetting.schedule_type) }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="!clockSetting.fixed_working_days">
              允許調班:
              {{ clockSetting.allow_shift_swap ? "是" : "否" }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="clockSetting.fixed_working_days"
              >休息日:
              {{
                weekdays.find((day) => day.value === clockSetting.recess_day)
                  .text
              }}</v-list-item-subtitle
            >
            <v-list-item-subtitle v-if="clockSetting.fixed_working_days"
              >例假日:
              {{
                weekdays.find((day) => day.value === clockSetting.regular_day)
                  .text
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold" :style="{ color: 'red' }">
          未打卡通知
        </h6>
        <v-list-item class="px-0">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-message-processing-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              clockSetting.notify == true ? "是" : "否"
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <h6 class="text-subtitle-1 font-weight-bold" :style="{ color: 'red' }">
          上下班打卡提醒
        </h6>
        <v-list-item class="px-0">
          <v-list-item-icon class="me-3">
            <v-icon color="primary">mdi-clock-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              clockSetting.workday_clock_notify_enable == true ? "是" : "否"
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>

    <v-row class="mt-3"> </v-row>

    <!-- QR Code Dialog -->
    <v-dialog v-model="showQRDialog" max-width="50%">
      <v-card>
        <v-card-title class="headline d-flex align-center justify-space-between"
          >QR碼
          <div
            v-if="isDynamicQR && countdown > 0"
            class="text-subtitle-1 red--text font-weight-bold"
          >
            {{ countdown }}s 後更新
          </div>
        </v-card-title>
        <v-card-text class="text-center">
          <v-img
            :src="QRCodeURL"
            alt="QR Code"
            width="340"
            height="360"
            class="mx-auto"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              ms-auto
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            @click="downQRFile()"
            >下載</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="showQRDialog = false"
            >關閉</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Progress Dialog -->
    <progress-dialog
      :visible.sync="progressDialog.visible"
      :message="progressDialog.message"
    />

    <!-- Info Dialog -->
    <info-dialog
      :visible.sync="infoDialog.visible"
      :title="infoDialog.title"
      :message="infoDialog.message"
      :yes-button-text="infoDialog.yesButtonText"
      :yes-callback="infoDialog.yesCallback"
    />
    <!-- Confirm Dialog -->
    <confirm-dialog
      :visible.sync="confirmDialog.visible"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :yes-button-text="confirmDialog.yesButtonText"
      :no-button-text="confirmDialog.noButtonText"
      :yes-callback="confirmDialog.yesCallback"
    />
  </v-card>
</template>

<script>
import { PART_TIME_TYPE } from "@/constants";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import InfoDialog from "@/components/Common/InfoDialog.vue";
import ConfirmDialog from "@/components/Common/ConfirmDialog.vue";

export default {
  name: "CompanyClockSetting",
  components: {
    ProgressDialog,
    InfoDialog,
    ConfirmDialog,
  },
  props: {
    clockSetting: {
      type: Object,
      required: true,
    },
    onlyOneSetting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      multple_gps: true,
      gpsItems: [],
      editMode: false,
      editedClockSetting: {},
      showQRDialog: false,
      isDynamicQR: false,
      dynamicQRCodeData: null,
      qrRefreshTimer: null,
      countdown: 120,
      countdownInterval: null,
      fetchingGPS: false,
      progressDialog: {
        visible: false,
        message: "正在初始化打卡設定...",
      },
      infoDialog: {
        visible: false,
        title: "操作成功",
        message: "打卡設定已成功更新！",
        yesButtonText: "確定",
        yesCallback: null,
      },
      timeMenus: {
        clockIn: false,
        clockOut: false,
        lunchStart: false,
        lunchEnd: false,
        rest1Start: false,
        rest1End: false,
      },
      confirmDialog: {
        visible: false,
        title: "確認刪除",
        message: "您確定要刪除此打卡設定嗎？此操作無法復原。",
        yesButtonText: "刪除",
        noButtonText: "取消",
        yesCallback: null,
      },
      // Weekday options: Chinese label, enum value
      weekdays: [
        { text: "星期日", value: "Sunday" },
        { text: "星期一", value: "Monday" },
        { text: "星期二", value: "Tuesday" },
        { text: "星期三", value: "Wednesday" },
        { text: "星期四", value: "Thursday" },
        { text: "星期五", value: "Friday" },
        { text: "星期六", value: "Saturday" },
      ],
      scheduleTypeOptions: [
        { text: "一般班", value: "GENERAL" },
        { text: "雙週彈性", value: "BIWEEKLY_FLEX" },
        { text: "四週彈性", value: "FOURWEEK_FLEX" },
      ],
      partTimeTypeItems: Object.keys(PART_TIME_TYPE).map((k) => ({
        text: PART_TIME_TYPE[k],
        value: Number(k),
      })),
    };
  },
  computed: {
    // formTitle() {
    //   return this.editedIndex === -1 ? "New Item" : "Edit Item";
    // },
    QRCodeURL() {
      if (this.isDynamicQR && this.dynamicQRCodeData) {
        return `data:image/png;base64,${this.dynamicQRCodeData}`;
      }
      return `${process.env.VUE_APP_API_URL}/resource/qr/qr_${this.clockSetting.qr_fixed}.png`;
    },
    isFlexMode() {
      const target = this.editMode
        ? this.editedClockSetting
        : this.clockSetting;
      if (!target) return false;
      return target.fixed_working_days === false;
    },
  },
  watch: {
    // When the clock-in time menu closes (e.g., user opens another picker),
    // ensure lunch times are recalculated too.
    "timeMenus.clockIn"(val) {
      if (val === false) {
        this.updateLunchByClockIn();
      }
    },
    showQRDialog(val) {
      if (!val) {
        this.stopQRRefresh();
      }
    },
  },
  beforeDestroy() {
    this.stopQRRefresh();
  },
  methods: {
    validateNonNegativeFields() {
      const targets = [
        { key: "clock_in_notify", label: "上班通知分鐘" },
        { key: "clock_in_allow_time", label: "允許提前打卡分鐘" },
        { key: "clock_out_notify", label: "下班通知分鐘" },
        { key: "clock_out_allow_time", label: "允許遲到打卡分鐘" },
      ];

      for (const field of targets) {
        const value = this.editedClockSetting[field.key];
        if (value != null && Number(value) < 0) {
          this.infoDialog.title = "資料不完整";
          this.infoDialog.message = `${field.label} 必須大於等於 0`;
          this.infoDialog.visible = true;
          return false;
        }
      }
      return true;
    },
    nonNegativeRule(value) {
      if (value === null || value === undefined || value === "") return true;
      const num = Number(value);
      return (!Number.isNaN(num) && num >= 0) || "必須大於等於 0";
    },
    // ----- GPS Multi helpers -----
    initGpsItemsFromEdited() {
      const locStr = (this.editedClockSetting?.location || "").toString();
      const gpsStr = (this.editedClockSetting?.gps || "").toString();
      const locs = locStr ? locStr.split(";") : [];
      const gpss = gpsStr ? gpsStr.split(";") : [];
      const n = Math.max(locs.length, gpss.length);
      this.gpsItems = Array.from({ length: n || 1 }).map((_, i) => ({
        location: (locs[i] || "").trim(),
        gps: (gpss[i] || "").trim(),
      }));
      this.syncCombinedGpsFields();
    },
    syncCombinedGpsFields() {
      const loc = this.gpsItems
        .map((it) => it.location?.trim())
        .filter((v) => v)
        .join(";");
      const gps = this.gpsItems
        .map((it) => it.gps?.trim())
        .filter((v) => v)
        .join(";");
      this.$set(this.editedClockSetting, "location", loc);
      this.$set(this.editedClockSetting, "gps", gps);
    },
    addGpsItem() {
      this.gpsItems.push({ location: "", gps: "" });
      this.syncCombinedGpsFields();
    },
    removeGpsItem(index) {
      this.gpsItems.splice(index, 1);
      if (this.gpsItems.length === 0)
        this.gpsItems.push({ location: "", gps: "" });
      this.syncCombinedGpsFields();
    },
    async fetchItemGPSFromAddress(index) {
      const item = this.gpsItems[index];
      if (!item || !item.location) return;
      const prevLocation = this.editedClockSetting.location;
      try {
        // reuse single fetch by temporarily setting edited field
        this.editedClockSetting.location = item.location;
        await this.fetchGPSFromAddress();
        // fetchGPSFromAddress sets editedClockSetting.gps
        item.gps = this.editedClockSetting.gps;
      } finally {
        this.editedClockSetting.location = prevLocation;
        this.syncCombinedGpsFields();
      }
    },
    openItemGPSInGoogleMaps(index) {
      const item = this.gpsItems[index];
      if (!item || !this.isValidGPS(item.gps)) return;
      const prevGps = this.editedClockSetting.gps;
      this.editedClockSetting.gps = item.gps;
      this.openGPSInGoogleMaps();
      this.editedClockSetting.gps = prevGps;
    },
    getPartTimeTypeLabel(type) {
      return PART_TIME_TYPE[type] || "未設定";
    },
    getScheduleTypeLabel(value) {
      const found = this.scheduleTypeOptions.find((opt) => opt.value === value);
      return found ? found.text : "未設定";
    },
    // Format various time representations to HH:mm for display only
    formatToHHmm(value) {
      if (!value) return "";
      if (typeof value === "string") {
        // Already HH:mm
        if (/^\d{2}:\d{2}$/.test(value)) return value;
        // Extract HH:mm from HH:mm:ss
        const mm = value.match(/^(\d{2}:\d{2})(?::\d{2})?$/);
        if (mm) return mm[1];
        // Try ISO or other date string
        const d = new Date(value);
        if (!isNaN(d.getTime())) {
          const hh = String(d.getHours()).padStart(2, "0");
          const mi = String(d.getMinutes()).padStart(2, "0");
          return `${hh}:${mi}`;
        }
        return value;
      }
      // Unknown type, return as-is
      return String(value);
    },
    // Parse time (HH:mm or HH:mm:ss or Date/string) to minutes since 00:00
    parseTimeToMinutes(value) {
      if (!value) return null;
      if (typeof value === "string") {
        const hhmm = value.match(/^(\d{2}):(\d{2})(?::\d{2})?$/);
        if (hhmm) {
          const h = parseInt(hhmm[1], 10);
          const m = parseInt(hhmm[2], 10);
          return h * 60 + m;
        }
        const d = new Date(value);
        if (!isNaN(d.getTime())) return d.getHours() * 60 + d.getMinutes();
        return null;
      }
      if (value instanceof Date) {
        return value.getHours() * 60 + value.getMinutes();
      }
      return null;
    },
    // Convert minutes since 00:00 to HH:mm string with 24h wrap
    minutesToHHmm(totalMinutes) {
      if (totalMinutes == null || isNaN(totalMinutes)) return "";
      const mins = ((totalMinutes % 1440) + 1440) % 1440; // safe modulo
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },
    updateLunchByClockIn() {
      const fixed = this.editedClockSetting?.fixed_working_days;
      const inMins = this.parseTimeToMinutes(
        this.editedClockSetting?.clock_in_time
      );
      if (!fixed || inMins == null) return;
      // +4 and +5 with 24h wrap
      const start = inMins + 4 * 60;
      const end = inMins + 5 * 60;
      this.editedClockSetting.lunch_break_start = this.minutesToHHmm(start);
      this.editedClockSetting.lunch_break_end = this.minutesToHHmm(end);
      // also set off-work time to +9h with 24h wrap
      const clockOut = inMins + 9 * 60;
      this.editedClockSetting.clock_out_time = this.minutesToHHmm(clockOut);
    },
    handleClockInChange() {
      // recalc then close
      this.updateLunchByClockIn();
      this.timeMenus.clockIn = false;
    },
    toggleEditMode() {
      // Enter edit mode with a deep copy of current settings
      this.editMode = true;
      this.editedClockSetting = JSON.parse(JSON.stringify(this.clockSetting));
      // initialize gps items for multi mode
      if (this.multple_gps) this.initGpsItemsFromEdited();
    },

    cancelEdit() {
      this.editMode = false;
      this.editedClockSetting = {};
      this.gpsItems = [];
    },
    async createNewClockSetting() {
      try {
        if (this.editedClockSetting.gps_enable) {
          if (
            !this.editedClockSetting.gps ||
            !this.editedClockSetting.location
          ) {
            this.infoDialog.title = "資料不完整";
            this.infoDialog.message = "啟用 GPS 打卡時，需填寫地址與 GPS 位置";
            this.infoDialog.visible = true;
            return;
          }
          if (String(this.editedClockSetting.location).trim().length < 3) {
            this.infoDialog.title = "資料不完整";
            this.infoDialog.message = "地址需至少 3 個字";
            this.infoDialog.visible = true;
            return;
          }
          if (!this.isValidGPS(this.editedClockSetting.gps)) {
            this.infoDialog.title = "格式錯誤";
            this.infoDialog.message =
              "GPS 位置需為「緯度,經度」，中間以逗號分隔";
            this.infoDialog.visible = true;
            return;
          }
          if (Number(this.editedClockSetting.gps_scope) <= 10) {
            this.infoDialog.title = "資料不完整";
            this.infoDialog.message = "GPS 範圍需大於 10 公尺";
            this.infoDialog.visible = true;
            return;
          }
        }
        this.progressDialog.message = "正在新增打卡設定...";
        this.progressDialog.visible = true;

        // Persist changes
        await this.$axios.post(
          `/api/company-clock-settings`,
          this.editedClockSetting
        );

        this.progressDialog.visible = false;
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "打卡設定已成功新增！";
        this.infoDialog.visible = true;
        // defer refresh until user confirms
        this.infoDialog.yesCallback = () => {
          if (
            this.$parent &&
            typeof this.$parent.fetchClockSettings === "function"
          ) {
            this.$parent.fetchClockSettings();
          }
          this.infoDialog.yesCallback = null;
        };

        this.editMode = false;
      } catch (error) {
        console.error("Error creating clock setting:", error);
        this.progressDialog.visible = false;
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = "新增打卡設定失敗，請稍後再試！";
        this.infoDialog.visible = true;
      }
    },

    async saveChanges() {
      if (!this.validateNonNegativeFields()) return;
      if (this.editedClockSetting.rest_1_start_enable) {
        const restStartMinutes = this.parseTimeToMinutes(
          this.editedClockSetting.rest_1_start
        );
        const restEndMinutes = this.parseTimeToMinutes(
          this.editedClockSetting.rest_1_end
        );
        const clockOutMinutes = this.parseTimeToMinutes(
          this.editedClockSetting.clock_out_time
        );

        if (
          restStartMinutes == null ||
          restEndMinutes == null ||
          clockOutMinutes == null
        ) {
          this.infoDialog.title = "資料不完整";
          this.infoDialog.message = "啟用休息2，請設定休息一與下班時間";
          this.infoDialog.visible = true;
          return;
        }
      }
      if (this.editedClockSetting.gps_enable) {
        if (!this.editedClockSetting.gps || !this.editedClockSetting.location) {
          this.infoDialog.title = "資料不完整";
          this.infoDialog.message = "啟用 GPS 打卡時，需填寫地址與 GPS 位置";
          this.infoDialog.visible = true;
          return;
        }
        if (String(this.editedClockSetting.location).trim().length < 3) {
          this.infoDialog.title = "資料不完整";
          this.infoDialog.message = "地址需至少 3 個字";
          this.infoDialog.visible = true;
          return;
        }
        if (!this.isValidGPS(this.editedClockSetting.gps)) {
          this.infoDialog.title = "格式錯誤";
          this.infoDialog.message = "GPS 位置需為「緯度,經度」，中間以逗號分隔";
          this.infoDialog.visible = true;
          return;
        }
        if (Number(this.editedClockSetting.gps_scope) <= 10) {
          this.infoDialog.title = "資料不完整";
          this.infoDialog.message = "GPS 範圍需大於 10 公尺";
          this.infoDialog.visible = true;
          return;
        }
      }
      if (!this.editedClockSetting.id) {
        return await this.createNewClockSetting();
      }
      try {
        this.progressDialog.message = "正在儲存打卡設定...";
        this.progressDialog.visible = true;

        // Persist changes
        await this.$axios.put(
          `/api/company-clock-settings/${this.clockSetting.id}`,
          this.editedClockSetting
        );

        this.progressDialog.visible = false;
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "打卡設定已成功更新！";
        this.infoDialog.visible = true;
        // Fetch after user clicks OK
        this.infoDialog.yesCallback = () => {
          if (
            this.$parent &&
            typeof this.$parent.fetchClockSettings === "function"
          ) {
            this.$parent.fetchClockSettings();
          }
          // clear callback
          this.infoDialog.yesCallback = null;
        };

        this.editMode = false;

        // Re-initialize daily clock settings after successful update
        await this.init_clock();
      } catch (error) {
        console.error("Error updating clock settings:", error);
        this.progressDialog.visible = false;
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = "更新打卡設定失敗，請稍後再試！";
      }
    },
    async init_clock(clean = false) {
      // Re-initialize daily clock settings
      // TODO 邏輯是?
      try {
        // Show progress dialog
        this.progressDialog.visible = true;

        let data = { company_id: this.clockSetting.company_id };
        if (clean) {
          data = {
            company_id: this.clockSetting.company_id,
            clean: true,
          };
        }
        // Make API call
        const response = await this.$axios.post(
          "/api/employee-clock-settings/reset-init-daily",
          data
        );

        console.log("Clock settings initialized:", response.data);

        // Hide progress dialog
        this.progressDialog.visible = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "打卡設定已成功更新！";
        this.infoDialog.visible = true;
      } catch (error) {
        console.error("Error initializing clock settings:", error);

        // Hide progress dialog
        this.progressDialog.visible = false;
        // Show error dialog
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = "初始化打卡設定失敗，請稍後再試！";
        this.infoDialog.visible = true;
      }
    },
    async generateQRCode(id) {
      try {
        this.isDynamicQR = false;
        console.log("generateQRCode", id);
        // Show progress dialog
        this.progressDialog.message = "正在產生QR碼...";
        this.progressDialog.visible = true;

        // Make API call to generate QR code
        const response = await this.$axios.get(
          `/api/company-clock-settings/qrcode/${id}`
        );

        console.log("QR code generated:", response.data);

        // Hide progress dialog
        this.progressDialog.visible = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "QR碼已成功產生！";
        this.infoDialog.yesCallback = () => {
          if (
            this.$parent &&
            typeof this.$parent.fetchClockSettings === "function"
          ) {
            this.$parent.fetchClockSettings();
          }
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;
      } catch (error) {
        console.error("Error generating QR code:", error);

        // Hide progress dialog
        this.progressDialog.visible = false;

        // Show error dialog
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = "產生QR碼失敗，請稍後再試！";
        this.infoDialog.visible = true;
      }
    },
    async generateDynamicQRCode(id) {
      try {
        this.isDynamicQR = true;
        await this.fetchDynamicQRCode(id);
        this.showQRDialog = true;

        // Reset and start timer (2 minutes = 120,000ms)
        this.stopQRRefresh();

        // Start refresh interval
        this.qrRefreshTimer = setInterval(() => {
          this.fetchDynamicQRCode(id);
        }, 120000);

        // Start countdown interval
        this.countdown = 120;
        this.countdownInterval = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            this.countdown = 120;
          }
        }, 1000);
      } catch (error) {
        console.error("Error starting dynamic QR code:", error);
        alert("啟動動態QR碼失敗");
      }
    },
    async fetchDynamicQRCode(id) {
      try {
        const response = await this.$axios.get(
          `/api/company-clock-settings/qrcode/dynamic/${id}?generate_image=false`
        );
        if (response.data && response.data.extra) {
          this.dynamicQRCodeData = response.data.extra.qr_dynamic_base64;
          this.countdown = 120; // reset countdown on successful fetch
        }
      } catch (error) {
        console.error("Error fetching dynamic QR code:", error);
      }
    },
    stopQRRefresh() {
      if (this.qrRefreshTimer) {
        clearInterval(this.qrRefreshTimer);
        this.qrRefreshTimer = null;
      }
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    async downQRFile() {
      this.progressDialog.message = "正在下載 QR 碼...";
      this.progressDialog.visible = true;
      try {
        let blob;
        if (this.isDynamicQR && this.dynamicQRCodeData) {
          // Convert base64 to blob
          const byteCharacters = atob(this.dynamicQRCodeData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          blob = new Blob([byteArray], { type: "image/png" });
        } else {
          const response = await fetch(this.QRCodeURL);
          if (!response.ok) {
            throw new Error(`網路回應錯誤: ${response.statusText}`);
          }
          blob = await response.blob();
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const fileName = this.isDynamicQR
          ? `dynamic_qrcode_${this.clockSetting.id}.png`
          : `qrcode_${this.clockSetting.qr_fixed}.png`;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);

        this.progressDialog.visible = false;
      } catch (error) {
        console.error("Error downloading QR code:", error);
        this.progressDialog.visible = false;
        this.infoDialog.title = "下載失敗";
        this.infoDialog.message = `無法下載QR碼，請稍後再試。 ${error.message}`;
        this.infoDialog.visible = true;
      }
    },
    confirmClearData() {
      // Show confirm dialog for clearing data
      this.confirmDialog.title = "確認清除資料";
      this.confirmDialog.message = "是否要清除資料並且把打卡紀錄一併清除";
      this.confirmDialog.yesButtonText = "確認";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.init_clock(true);
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },
    confirmReload() {
      // Show confirm dialog for reloading data
      this.confirmDialog.title = "確認重新載入";
      this.confirmDialog.message = "重新讀取打卡資料並更新";
      this.confirmDialog.yesButtonText = "確認";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.init_clock();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },
    async deleteClockSetting() {
      // Open confirm dialog; perform deletion only on confirm
      this.confirmDialog.title = "確認刪除";
      this.confirmDialog.message = "您確定要刪除此打卡設定嗎？此操作無法復原。";
      this.confirmDialog.yesButtonText = "刪除";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        try {
          this.progressDialog.message = "正在刪除打卡設定...";
          this.progressDialog.visible = true;

          await this.$axios.delete(
            `/api/company-clock-settings/${this.clockSetting.id}`
          );

          this.progressDialog.visible = false;
          this.infoDialog.title = "操作成功";
          this.infoDialog.message = "打卡設定已刪除！";
          this.infoDialog.visible = true;

          // After user confirms info dialog, refresh list
          this.infoDialog.yesCallback = () => {
            if (
              this.$parent &&
              typeof this.$parent.fetchClockSettings === "function"
            ) {
              this.$parent.fetchClockSettings();
            }
            this.infoDialog.yesCallback = null;
          };

          this.editMode = false;
        } catch (error) {
          console.error("Error deleting clock setting:", error);
          this.progressDialog.visible = false;
          this.infoDialog.title = "操作失敗";
          this.infoDialog.message = "刪除打卡設定失敗，請稍後再試！";
          this.infoDialog.visible = true;
        }
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },
    async fetchGPSFromAddress() {
      if (!this.editedClockSetting.location) {
        return;
      }

      try {
        this.fetchingGPS = true;
        const address = encodeURIComponent(this.editedClockSetting.location);

        const response = await this.$axios.get(
          `/api/company-clock-settings/geocode?address=${address}`
        );

        if (response.data.success) {
          this.editedClockSetting.gps = response.data.gps;

          this.infoDialog.title = "取得成功";
          this.infoDialog.message = `經緯度已更新為: ${response.data.gps}`;
          this.infoDialog.visible = true;
        } else {
          this.infoDialog.title = "取得失敗";
          this.infoDialog.message = "無法取得該地址的經緯度";
          this.infoDialog.visible = true;
        }
      } catch (error) {
        console.error("Error fetching GPS coordinates:", error);
        this.infoDialog.title = "取得失敗";
        this.infoDialog.message = "呼叫 API 時發生錯誤，請稍後再試！";
        this.infoDialog.visible = true;
      } finally {
        this.fetchingGPS = false;
      }
    },
    openGPSInGoogleMaps() {
      const gps = this.editedClockSetting.gps;
      if (!this.isValidGPS(gps)) return;
      const [latStr, lonStr] = gps.split(",");
      console.log("openGPSInGoogleMaps", latStr, lonStr);
      const lat = parseFloat(latStr.trim());
      const lon = parseFloat(lonStr.trim());
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
      window.open(url, "_blank");
    },
    isValidGPS(value) {
      if (!value || typeof value !== "string") return false;
      const parts = value.split(",");
      if (parts.length < 2) return false;
      const lat = parseFloat(parts[0].trim());
      const lon = parseFloat(parts[1].trim());
      if (isNaN(lat) || isNaN(lon)) return false;
      if (lat < -90 || lat > 90) return false;
      if (lon < -180 || lon > 180) return false;
      return true;
    },

    async checkAbsentClock() {
      try {
        const response = await this.$axios.post(
          `/api/company-clock-settings/check-missing-clock/${this.clockSetting.id}`
        );
        // Display the message from the response using dialog
        if (response.data && response.data.message) {
          this.infoDialog.title = "檢查結果";
          this.infoDialog.message = response.data.message;
          this.infoDialog.yesButtonText = "確定";
          this.infoDialog.yesCallback = null;
          this.infoDialog.visible = true;
        } else {
          alert("無效的回應資料");
        }
      } catch (error) {
        console.error("Error checking absent clock-ins:", error);
        const errorMsg =
          error.response?.data?.message || error.message || "檢查未打卡失敗";
        this.infoDialog.title = "檢查失敗";
        this.infoDialog.message = errorMsg;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },
  },
};
</script>

<style scoped>
/* Center the v-time-picker title horizontally within this component */
::v-deep .v-time-picker-title {
  justify-content: center !important;
  text-align: center !important;
}
</style>
